/* Floating Flame PDP sections (ff-*): gallery, buy box with add-ons, sticky bar, reviews browser. */
(function () {
  if (window.__ffpInit) return;
  window.__ffpInit = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function el(t, c, txt) { var e = document.createElement(t); if (c) e.className = c; if (txt != null) e.textContent = txt; return e; }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    if (g.__ffp) return; g.__ffp = true;
    var track = $('.track', g), slides = $$('.slide', g), count = $('.count', g), thumbs = $('.thumbs', g);
    if (!track || !slides.length) return;
    var idx = 0;
    var tbs = slides.map(function (s, i) {
      var im = $('img', s), b = el('button', 'thumb' + (s.classList.contains('render') ? ' render' : ''));
      b.type = 'button'; b.setAttribute('aria-label', 'Show photo ' + (i + 1));
      if (im) { var t = el('img'); t.src = im.currentSrc || im.src; t.alt = ''; t.loading = 'lazy'; t.width = 64; t.height = 64; b.appendChild(t); }
      b.addEventListener('click', function () { go(i); });
      if (thumbs) thumbs.appendChild(b);
      return b;
    });
    if (slides.length < 2) { if (thumbs) thumbs.hidden = true; $$('.navbtn', g).forEach(function (n) { n.hidden = true; }); }
    function mark(i) {
      idx = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      tbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var tb = tbs[i];
      if (thumbs && tb) {
        if (thumbs.scrollHeight > thumbs.clientHeight + 1) thumbs.scrollTo({ top: tb.offsetTop - thumbs.clientHeight / 2 + tb.clientHeight / 2, behavior: 'smooth' });
        else if (thumbs.scrollWidth > thumbs.clientWidth + 1) thumbs.scrollTo({ left: tb.offsetLeft - thumbs.clientWidth / 2 + tb.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== idx && slides[i]) mark(i); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
    var p = $('.navbtn.prev', g), n = $('.navbtn.next', g);
    if (p) p.addEventListener('click', function () { go(idx - 1); });
    if (n) n.addEventListener('click', function () { go(idx + 1); });
    mark(0);
  }

  /* ---------- Money ---------- */
  function money(cents, sym, cur) {
    var whole = cents % 100 === 0, v = (cents / 100).toFixed(whole ? 0 : 2);
    var parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (sym || '$') + parts.join('.') + (cur ? ' ' + cur : '');
  }

  /* ---------- Buy box ---------- */
  function initBuy(root) {
    if (root.__ffp) return; root.__ffp = true;
    var form = $('form[data-ffp-form]', root);
    if (!form) return;
    var sym = root.getAttribute('data-sym') || '$', cur = root.getAttribute('data-cur') || '';
    var base = +root.getAttribute('data-base') || 0;
    var qtyIn = $('input[name="quantity"]', form), addons = $$('input[data-addon]', root);
    var atc = $('button.atc', form), err = $('.ferr', form);
    var totals = $$('[data-total]', root);

    function qty() { var q = parseInt(qtyIn && qtyIn.value, 10); return isNaN(q) || q < 1 ? 1 : Math.min(q, 9); }
    function update() {
      var q = qty(), t = base * q;
      addons.forEach(function (a) { if (a.checked) t += (+a.getAttribute('data-price') || 0) * q; });
      totals.forEach(function (n) { n.textContent = money(t, sym, cur); });
    }
    $$('[data-q]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyIn.value = Math.max(1, Math.min(9, qty() + (+b.getAttribute('data-q')))); update(); });
    });
    if (qtyIn) qtyIn.addEventListener('change', function () { qtyIn.value = qty(); update(); });
    addons.forEach(function (a) { a.addEventListener('change', update); });

    function showErr(msg) { if (!err) return; err.textContent = msg; err.hidden = !msg; }
    function busy(on) {
      [atc, $('[data-sticky-atc]', root)].forEach(function (b) { if (!b) return; if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); b.disabled = !!on; });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc && atc.getAttribute('aria-busy') === 'true') return;
      showErr('');
      var q = qty(), vid = +$('input[name="id"]', form).value;
      var items = [{ id: vid, quantity: q }];
      addons.forEach(function (a) { if (a.checked) items.push({ id: +a.getAttribute('data-addon'), quantity: q }); });
      var drawer = document.querySelector('cart-drawer');
      var body = items.length === 1 ? { id: vid, quantity: q } : { items: items };
      if (drawer && typeof drawer.renderContents === 'function') { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      busy(true);
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) { showErr(res.j.description || res.j.message || 'Could not add to cart. Please try again.'); return; }
          var j = res.j;
          try {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: vid, cartData: j });
          } catch (x) {}
          if (drawer && j.sections) {
            j.id = vid;
            drawer.classList.remove('is-empty');
            try { drawer.renderContents(j); return; } catch (x) {}
          }
          window.location.href = root_url + 'cart';
        })
        .catch(function () { showErr('Could not add to cart. Please check your connection and try again.'); })
        .then(function () { busy(false); });
    });

    /* Sticky bar (phones) */
    var sticky = $('[data-sticky]', root);
    if (sticky) {
      var satc = $('[data-sticky-atc]', sticky);
      if (satc) satc.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
      if ('IntersectionObserver' in window && atc) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(atc);
      }
    }
    update();
  }

  /* ---------- Reviews browser (Judge.me public widget feed) ---------- */
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var WORD = ['', 'one-star', 'two-star', 'three-star', 'four-star', 'five-star'];
  function initReviews(root) {
    if (root.__ffp) return; root.__ffp = true;
    var SHOP = root.getAttribute('data-shop'), PID = root.getAttribute('data-pid'), PER = 10;
    var API = 'https://judge.me/reviews/reviews_for_widget?url=' + SHOP + '&shop_domain=' + SHOP + '&platform=shopify&product_id=' + PID;
    var open = document.querySelector('[aria-controls="' + root.id + '"]');
    if (!open || !SHOP || !PID) return;
    var list = $('.ffr-list', root), status = $('.ffr-status', root), more = $('[data-ffr-more]', root);
    var sortSel = $('[data-ffr-sort]', root), allChip = $('[data-ffr-all]', root), phChip = $('[data-ffr-ph]', root);
    var bars = $$('.ffr-bar', root), lb = $('.ffr-lb', root), lbImg = $('img', lb);
    var st = { sort: 'created_at:desc', rating: 0, photos: false, page: 0, total: 0, loaded: 0, busy: false, started: false, done: false };

    function q(page) {
      var p = st.sort.split(':'), srt = p[0], dir = p[1];
      if (st.photos && srt !== 'with_pictures') { srt = 'with_pictures'; dir = 'desc'; }
      var u = API + '&page=' + page + '&per_page=' + PER + '&sort_by=' + srt + '&sort_dir=' + dir;
      if (st.rating) u += '&filter_rating=' + st.rating;
      return u;
    }
    function get(u) { return fetch(u, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); }); }
    function nameOf(n) { n = (n || '').trim().replace(/\s+/g, ' '); if (!n) return 'Verified buyer'; var p = n.split(' '); if (p.length < 2) return p[0]; return p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.'; }
    function dateOf(iso) { var d = new Date(iso); if (isNaN(d)) return ''; return MON[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear(); }
    function starsOf(n) { var w = el('span', 'stars'); w.setAttribute('role', 'img'); w.setAttribute('aria-label', n + ' out of 5 stars'); for (var i = 1; i <= 5; i++) w.appendChild(i <= n ? document.createTextNode('★') : el('s', null, '★')); return w; }
    function parse(html) {
      var d = document.createElement('div'); d.innerHTML = html || '';
      return $$('.jdgm-rev', d).map(function (e) {
        var body = $('.jdgm-rev__body', e), paras = [];
        if (body) { var ps = $$('p', body); if (ps.length) ps.forEach(function (p) { var t = p.textContent.trim(); if (t) paras.push(t); }); else { var t = body.textContent.trim(); if (t) paras.push(t); } }
        var pics = $$('.jdgm-rev__pic-link', e).map(function (a) {
          var big = a.getAttribute('data-mfp-src') || a.getAttribute('href') || '', im = $('img', a);
          var sm = im ? (im.getAttribute('data-src') || im.getAttribute('src') || '') : '';
          return { big: big, sm: sm || big };
        }).filter(function (p) { return /^https:\/\/[a-z0-9.-]*judgeme\.com\//.test(p.big); });
        var rep = $('.jdgm-rev__reply', e), tm = $('.jdgm-rev__timestamp', e), loc = $('.jdgm-rev__location', e), rt = $('.jdgm-rev__rating', e);
        return {
          rating: +(rt && rt.getAttribute('data-score')) || 5,
          author: nameOf(($('.jdgm-rev__author', e) || {}).textContent), loc: loc ? loc.textContent.trim() : '',
          date: tm ? dateOf(tm.getAttribute('datetime')) : '', title: (($('.jdgm-rev__title', e) || {}).textContent || '').trim(),
          paras: paras, pics: pics, verified: e.getAttribute('data-verified-buyer') === 'true',
          reply: rep ? rep.textContent.trim().replace(/\s+/g, ' ') : ''
        };
      });
    }
    var gallery = [], gi = 0;
    function showPic(i) { gi = (i + gallery.length) % gallery.length; lbImg.src = gallery[gi]; lb.hidden = false; $('.p', lb).hidden = $('.n', lb).hidden = gallery.length < 2; $('.x', lb).focus(); }
    function closePic() { lb.hidden = true; lbImg.removeAttribute('src'); }
    $('.x', lb).addEventListener('click', closePic);
    $('.p', lb).addEventListener('click', function (e) { e.stopPropagation(); showPic(gi - 1); });
    $('.n', lb).addEventListener('click', function (e) { e.stopPropagation(); showPic(gi + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closePic(); });
    document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') closePic(); if (e.key === 'ArrowRight') showPic(gi + 1); if (e.key === 'ArrowLeft') showPic(gi - 1); });

    function card(r) {
      var c = el('article', 'ffr-rev'), h = el('div', 'ffr-h');
      h.appendChild(starsOf(r.rating)); if (r.date) h.appendChild(el('time', 'ffr-date', r.date)); c.appendChild(h);
      var w = el('div', 'ffr-who', r.author); if (r.loc) w.appendChild(el('small', null, r.loc)); if (r.verified) w.appendChild(el('small', 'v', '✓ Verified buyer')); c.appendChild(w);
      if (r.title) c.appendChild(el('h4', null, r.title));
      if (r.paras.length) { var b = el('div', 'ffr-body'); r.paras.forEach(function (p) { b.appendChild(el('p', null, p)); }); c.appendChild(b); }
      if (r.pics.length) {
        var g = el('div', 'ffr-pics'), urls = r.pics.map(function (p) { return p.big; });
        r.pics.forEach(function (p, i) { var bt = el('button'); bt.type = 'button'; bt.setAttribute('aria-label', 'View photo ' + (i + 1) + ' from ' + r.author); var im = el('img'); im.src = p.sm; im.alt = ''; im.loading = 'lazy'; bt.appendChild(im); bt.addEventListener('click', function () { gallery = urls; showPic(i); }); g.appendChild(bt); });
        c.appendChild(g);
      }
      if (r.reply) { var rp = el('div', 'ffr-reply'); rp.appendChild(el('b', null, 'Reply from Floating Flame')); rp.appendChild(document.createTextNode(r.reply)); c.appendChild(rp); }
      return c;
    }
    function label() {
      var t = st.total, s = st.rating ? WORD[st.rating] + ' ' : '', p = st.photos || st.sort.indexOf('with_pictures') === 0 ? ' with photos' : '';
      if (!t || !st.loaded) return 'No ' + s + 'reviews' + p + ' yet.';
      if (st.done) return 'Showing all ' + st.loaded + ' ' + s + 'review' + (st.loaded === 1 ? '' : 's') + p;
      return 'Showing ' + Math.min(st.loaded, t) + ' of ' + t + ' ' + s + 'review' + (t === 1 ? '' : 's') + p;
    }
    function skel(n) { for (var i = 0; i < n; i++) list.appendChild(el('div', 'ffr-skel')); }
    function clearSkel() { $$('.ffr-skel', list).forEach(function (x) { x.remove(); }); }
    function fail() {
      clearSkel(); status.textContent = '';
      var p = el('p', 'ffr-err', 'Reviews could not load right now. '), a = el('a', null, 'See all reviews on Judge.me');
      a.href = 'https://judge.me/reviews/stores/floatingflame.com'; a.target = '_blank'; a.rel = 'noopener'; p.appendChild(a); list.appendChild(p); more.hidden = true;
    }
    var seq = 0;
    function load(reset) {
      if (st.busy && !reset) return;
      st.busy = true; var my = ++seq;
      if (reset) { st.page = 0; st.loaded = 0; list.textContent = ''; }
      st.page++; skel(reset ? 3 : 2); more.disabled = true;
      get(q(st.page)).then(function (j) {
        if (my !== seq) return;
        clearSkel(); st.total = +j.total_count || 0;
        var rs = parse(j.html); rs.forEach(function (r) { list.appendChild(card(r)); }); st.loaded += rs.length;
        st.done = !rs.length || st.page * PER >= st.total; more.hidden = st.done; more.disabled = false; status.textContent = label();
      }).catch(function () { if (my === seq) fail(); }).then(function () { if (my === seq) st.busy = false; });
    }
    function counts() {
      Promise.all([5, 4, 3, 2, 1].map(function (r) {
        return get(API + '&page=1&per_page=1&filter_rating=' + r).then(function (j) { return +j.total_count || 0; }).catch(function () { return null; });
      })).then(function (cs) {
        if (cs.some(function (c) { return c == null; })) return;
        var tot = cs.reduce(function (a, b) { return a + b; }, 0) || 1;
        cs.forEach(function (c, i) { var b = bars[i]; if (!b) return; $('em', b).textContent = c; $('b', b).style.width = (c / tot * 100).toFixed(1) + '%'; b.setAttribute('aria-label', (5 - i) + ' star reviews: ' + c); b.disabled = !c; });
      });
    }
    function sync() {
      bars.forEach(function (b) { b.setAttribute('aria-pressed', (+b.getAttribute('data-r') === st.rating) ? 'true' : 'false'); });
      allChip.setAttribute('aria-pressed', st.rating ? 'false' : 'true'); phChip.setAttribute('aria-pressed', st.photos ? 'true' : 'false');
    }
    bars.forEach(function (b) { b.addEventListener('click', function () { var r = +b.getAttribute('data-r'); st.rating = st.rating === r ? 0 : r; sync(); load(true); }); });
    allChip.addEventListener('click', function () { st.rating = 0; sync(); load(true); });
    phChip.addEventListener('click', function () { st.photos = !st.photos; if (!st.photos && st.sort.indexOf('with_pictures') === 0) { st.sort = 'created_at:desc'; sortSel.value = st.sort; } sync(); load(true); });
    sortSel.addEventListener('change', function () { st.sort = sortSel.value; if (st.sort.indexOf('with_pictures') === 0) st.photos = true; sync(); load(true); });
    more.addEventListener('click', function () { load(false); });
    var o = $('.o', open), c = $('.c', open);
    function toggle(show) {
      root.hidden = !show; open.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (o) o.hidden = show; if (c) c.hidden = !show;
      if (show && !st.started) { st.started = true; counts(); load(true); }
    }
    open.addEventListener('click', function () { var show = root.hidden; toggle(show); if (!show) open.scrollIntoView({ block: 'center' }); });
  }

  /* ---------- One accordion tab open at a time ---------- */
  function initAcc(acc) {
    if (acc.__ffp) return; acc.__ffp = true;
    var ds = $$('details', acc);
    ds.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        ds.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  function init(scope) {
    $$('[data-gal]', scope).forEach(initGallery);
    $$('[data-acc-one]', scope).forEach(initAcc);
    $$('[data-ffp-buy]', scope).forEach(initBuy);
    $$('[data-ffr]', scope).forEach(initReviews);
  }
  window.__ffpInitScope = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  /* Theme editor: re-init sections when they reload */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
